<template>
  <div>
    <span v-if="debug === 'true' || debug === true">{{version}}</span>
    <div v-if="loading">
      <b-spinner></b-spinner>
      Espere un momento. Estamos procesando su petición...
    </div>
    <div class="d-flex justify-content-center" v-else>
      <b-card class="w-75 p-1 border-0" no-body>
        <b-card-body style="padding: 0.7rem;">

          <b-row style="width: 100%">
          <b-col cols="3" v-for="(etapa, indx) in wizzard" v-bind:key="etapa.idEtapa" style="justify-content: left;">

              <b-row>
                <b-col cols="4" :style="etapa.success ? styleArrowFinalizado : styleArrowPendiente">
                  <div v-if="indx>0">
                    <font-awesome-icon   fixed-width  icon="arrow-right"  class="fa-3x"/>
                  </div>
                </b-col>
                <b-col cols="8">
                <div class="d-flex justify-content-center" >
                  <div v-if="!etapa.etapaActual" class="p-2" :style="etapa.success ? styleFinalizado : stylePendiente">
                    <b-img
                        alt="cero"
                        :src="require('../../assets/icons/'+etapa.icon+'.png')"
                        @click="cambiarEtapaBoton(indx)"
                    ></b-img>
                  </div>
                  <div v-else class="p-2" :style="styleActual">
                    <b-img
                        alt="cero"
                        :src="require('../../assets/icons/'+etapa.icon+'.png')"
                    ></b-img>
                  </div>
                </div>
                <div>
                <p style="color: #CECECE">Paso {{ etapa.idEtapa }}</p>
                <p style="margin: 0px;">{{ etapa.nombreEtapa }}</p>
                <div v-if="!etapa.etapaActual"
                       :style="etapa.success ? styleFinalizadoTraslucido: stylePendienteTraslucido">
                    <p v-if="etapa.success">
                      Terminado
                    </p>
                    <p v-else>Pendiente</p>
                  </div>
                  <div v-else :style="styleActualTraslucido">
                    <p>En progreso</p>
                  </div>
                </div>
              </b-col>
              </b-row>

          </b-col>
          </b-row>

        </b-card-body>
      </b-card>
    </div>

    <div v-if="activarEdicionAnfitrion && pti">

        <ImpresionPtiv5
            v-if="wizzard[0].etapaActual"
            :props="true"
            :idPtiProp="pti"
            :opcionProp="opcionSeleccionadaPti"
            :origen="origen"
        />

        <MetodosPagov5
            v-if="wizzard[1].etapaActual"
            @cambiarEtapaWizzardCaja="cambiarEtapa"
            :propsReadFromProps="true"
            :propsIdPti="pti"
            :propsIdSolicitud="idSolicitud"
            :propsIdEtapa="idEtapaPago"
            :propsIdSolicitudEtapa="idSolicitudEtapaPago"
            :propsIdUsuario="idPaciente"
            :editaAnfitrion="editaAnfitrion"
        />

        <DistribucionPagoPTIv5 v-if="wizzard[2].etapaActual"
            @cambiarEtapaWizzardCaja="cambiarEtapa"
            :propsReadFromProps="true"
            :propsIdPti="pti"
            :propsIdSolicitud="idSolicitud"
            :propsIdEtapa="idEtapaDistribucion"
            :propsIdSolicitudEtapa="idSolicitudEtapaDistribucion"
            :propsIdUsuario="idPaciente"
            :propsOpcion="opcionSeleccionadaPti"
        />

        <div class="mt-2 col-md-12"></div>

        <div v-if="etapaActual===1">
<!--          <b-button @click="cancelar">Cancelar</b-button>-->
          <b-button @click="siguiente" variant="primary">Siguiente</b-button>
        </div>
    </div>

  </div>
</template>

<script>

// import MetodosDePagoPTI from "@/views/PTI/NuevoM2/MetodosDePagoPTI";
// import DistribucionCobroPTI from "@/views/PTI/NuevoM2/DistribucionCobroPTI";
import VueNotifications from "vue-notifications";
// import ImpresionPTINuevoM2 from "@/views/PTI/NuevoM2/ImpresionPTI";

import ImpresionPtiv5 from "@/version5/negociacion/ImpresionPtiv5.vue";
import MetodosPagov5 from "@/version5/negociacion/MetodosPagov5";
import DistribucionPagoPTIv5 from "@/version5/negociacion/DistribucionPagoPTIv5";


export default {
  name: "wizzardCaja",
  components: {ImpresionPtiv5, MetodosPagov5, DistribucionPagoPTIv5},
  data() {
    return {
      version: process.env.VUE_APP_ENV_VERSION,
      debug: false,
      loading: false,

      pti:undefined,
      opcionSeleccionadaPti:undefined,
      origen: "CAJA",
      idEtapaResumen:undefined,
      idSolicitudEtapaResumen:undefined,
      idEtapaPago:undefined,
      idSolicitudEtapaPago:undefined,
      idEtapaDistribucion:undefined,
      idSolicitudEtapaDistribucion:undefined,
      idSolicitud:null,
      idUsuario: null,
      editaAnfitrion: true,

      wizzard: [
        {
          idEtapa: 1,
          success: false,
          nombreEtapa: "Validar PTI",
          icon: "archivo",
          etapaActual: false
        },
        {
          idEtapa: 2,
          success: false,
          nombreEtapa: "Formas de pago",
          icon: "pagos",
          etapaActual: false
        },
        {
          idEtapa: 3,
          success: false,
          nombreEtapa: "Distribución",
          icon: "distribucion",
          etapaActual: false
        },
        {
          idEtapa: 4,
          success: false,
          nombreEtapa: "Caja",
          icon: "caja",
          etapaActual: true
        },
      ],

      styleArrowPendiente: "color: #64ac0e;",
      styleArrowFinalizado: "color: #7CB518;",

      stylePendiente: "border-radius: 30px; width: 30%; background-color: #64ac0e;",
      styleFinalizado: "border-radius: 30px; width: 30%;background-color: #7CB518;",
      styleActual: "border-radius: 30px; width: 30%;background-color: #1B81AF;",
      stylePendienteTraslucido: "border-radius: 30px; background-color: #e0fdbd;",
      styleFinalizadoTraslucido: "border-radius: 30px; background-color: #DDECC3;",
      styleActualTraslucido: "border-radius: 30px; background-color: #D5EEF2;",

    }
  },
  props: {
    idPaciente: Number,
    activarEdicionAnfitrion: {
      type: Boolean,
      default: false
    },
  },
  validations() {

  },
  async created() {
    this.debug = this.$localStorageService.getDebug();
    history.forward();
    await this.obtenerInformacionRenegociarPtiPaciente();
    if (this.activarEdicionAnfitrion) {
      this.restablecerEtapaInicial();
    }
  },
  methods: {
    async obtenerInformacionRenegociarPtiPaciente() {
      const parametros = {idPaciente: this.idPaciente}
      this.$http
          .post(
              this.$api +
              "caja/obtener/info/renegociarPTI", parametros
          )
          .then((response) => {
             const datos = response.data.data;

                this.pti = datos.idPti;
                this.opcionSeleccionadaPti = datos.opcionSeleccionadaPti;
                this.idEtapaResumen = datos.idEtapaResumen;
                this.idSolicitudEtapaResumen = datos.idSolicitudEtapaResumen;
                this.idEtapaPago = datos.idEtapaPago;
                this.idSolicitudEtapaPago = datos.idSolicitudEtapaPago;
                this.idEtapaDistribucion = datos.idEtapaDistribucion;
                this.idSolicitudEtapaDistribucion = datos.idSolicitudEtapaDistribucion;
                this.idSolicitud = datos.idSolicitud;
          })
          .catch((err) => {
            this.errorMensaje(err);
          })
          .finally(() =>
            this.loading = false
          );
    },
    cancelar() {
      this.$emit("cambiarActivarEdicionAnfitrion", false);
      this.restablecerEtapaCaja();
    },
    cambiarEtapaBoton(etapa) {
      if(this.etapaActual===1) {
        this.cambiarEtapa1(etapa, false)
      }
    },
    cambiarEtapa(etapa) {
      this.cambiarEtapa1(etapa, false)
    },
    cambiarEtapa1(etapa, forzar) {

      if (this.activarEdicionAnfitrion || forzar) {
        this.wizzard.forEach(et => et.etapaActual = false);
        this.wizzard[etapa].etapaActual = true;

        if (etapa === 3) {
          this.cancelar();
        }
      }
      this.obtenerInformacionRenegociarPtiPaciente();
    },
    restablecerEtapaCaja(){
      this.cambiarEtapa1(3, true);
    },
    restablecerEtapaInicial(){
      this.cambiarEtapa1(0, true);
    },
    siguiente() {
      this.cambiarEtapa(this.etapaActual);
    }
  },
  watch: {
    activarEdicionAnfitrion: function() {
      if (!this.activarEdicionAnfitrion) {
          this.restablecerEtapaCaja();
      } else {
          this.restablecerEtapaInicial();
      }
    }
  },
  computed: {
    etapaActual() {
      return this.wizzard.find(et => et.etapaActual).idEtapa;
    },
  },
  notifications: {
    errorMensaje: {
      type: VueNotifications.types.error,
      title: "Error",
      message: "Error al traer la información",
    }
  },

}
</script>

<style scoped>
.card-caja {
  background: #f6f6f6;
  border: none;
}

.datitos {
  font-size: small;
  padding: 0;
  margin: 0;
  color: rgb(84, 94, 103);
}

.datitosblack {
  font-size: small;
  padding: 0;
  margin: 0;
}

.datitos > p {
  margin-bottom: 0.5rem;
}

.txSesion > .card-body {
  padding: 0.5rem;
}
</style>
  